export const filterImagesBySelector = (el, selector) => {
    const elementInGallery = el.closest(selector);
    if (!elementInGallery) {
        return el;
    }
};
